export enum DocumentCategory {
  PerformanceBonus = 'PerformanceBonus',
  Bonus = 'Bonus',
  TaxInvoices = 'TaxInvoices',
  Invoices = 'Invoices'
}
